import { render, staticRenderFns } from "./LabelActions.vue?vue&type=template&id=2f902994&scoped=true&"
import script from "./LabelActions.vue?vue&type=script&lang=js&"
export * from "./LabelActions.vue?vue&type=script&lang=js&"
import style0 from "./LabelActions.vue?vue&type=style&index=0&id=2f902994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f902994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f902994')) {
      api.createRecord('2f902994', component.options)
    } else {
      api.reload('2f902994', component.options)
    }
    module.hot.accept("./LabelActions.vue?vue&type=template&id=2f902994&scoped=true&", function () {
      api.rerender('2f902994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/conversationBulkActions/LabelActions.vue"
export default component.exports